module.exports = __webpack_public_path__ + "img/logo-white.807840dc.png";